import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Одна заявка по лизингу во все компании',
  description: 'Повысьте вероятность одобрения и возможность быстрее совершить сделку',
  actions: {
    order: 'Подать заявку',
  },
} satisfies TMessages
